import { observable } from '@legendapp/state';

export type WinDisplayData = {
  betAmount: number;

  rowsCleared: number;
  winAmount: number;
};

type WinDisplayState = {
  isVisible: boolean;
  data: WinDisplayData | null;
  showWinDisplay: (data: WinDisplayData, duration?: number) => void;
  hideWinDisplay: () => void;
  cleanup: () => void;
};

let winDisplayTimeout: ReturnType<typeof setTimeout> | undefined;

export const winDisplayState$ = observable<WinDisplayState>({
  isVisible: false,
  data: null,
  showWinDisplay: (data: WinDisplayData, duration?: number) => {
    // Clear any existing timeout
    if (winDisplayTimeout) {
      clearTimeout(winDisplayTimeout);
    }

    // Set the display data and show
    winDisplayState$.data.set(data);
    winDisplayState$.isVisible.set(true);

    // Auto-hide after specified duration
    if (duration) {
      winDisplayTimeout = setTimeout(() => {
        winDisplayState$.isVisible.set(false);
      }, duration);
    }
  },
  hideWinDisplay: () => {
    if (winDisplayTimeout) {
      clearTimeout(winDisplayTimeout);
    }
    winDisplayState$.isVisible.set(false);
  },
  cleanup: () => {
    if (winDisplayTimeout) {
      clearTimeout(winDisplayTimeout);
      winDisplayTimeout = undefined;
    }
  },
});
